/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Gov_Starter_CopilotInputs */



/**
* | output |
* | --- |
* | "+€3/user/mo" |
*
* @param {Compare_Gov_Starter_CopilotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_gov_starter_copilot = /** @type {((inputs?: Compare_Gov_Starter_CopilotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Gov_Starter_CopilotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("+€3/Nutzer/Mo.")
	return /** @type {LocalizedString} */ ("+€3/user/mo")
});